import { useContext } from "react";
import { UiDataContext } from "./context";
import { UiData } from "./ui-data";

export function useUiData(): UiData {
	return useContext(UiDataContext);
}
